/**
 * Try to use high performance GPU on dual-GPU systems
 */
runOnHighPerformanceGPU();

/**
 * Use passive listeners to improve scrolling performance
 */
jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ){
    if ( ns.includes('noPreventDefault') ) {
      this.addEventListener('touchstart', handle, { passive: false });
    } else {
      this.addEventListener('touchstart', handle, { passive: true });
    }
  }
};

jQuery.event.special.touchend = {
  setup: function( _, ns, handle ){
    if ( ns.includes('noPreventDefault') ) {
      this.addEventListener('touchend', handle, { passive: false });
    } else {
      this.addEventListener('touchend', handle, { passive: true });
    }
  }
};

window.$document = $(document);
window.$window = $(window);
window.$html = $('html');
window.$pageWrapper = $('.page-wrapper');
window.$pageHeader = $('.header__wrapper-overlay-menu');
window.$barbaWrapper = $('[data-barba="wrapper"]');
window.$body = $('body');
window.$wrapperBackgrounds = $('.project-backgrounds');
window.$backgroundsOverlay = $('.project-backgrounds__overlay');
window.$overlay = $('.header__wrapper-overlay-menu');
window.$backgrounds = $('.project-backgrounds__background');
window.$backgroundLinks = $('a[data-post-id]');
window.$burger = $('#js-burger');
window.$header = $('.header');
window.$preloader = $('.preloader');
window.$curtains = $('.preloader__curtain');
window.$spinner = $('.js-spinner');
window.lastTop = 0;
window.isElementorLoaded = false;

/**
 * Default Theme Options
 * Used to prevent errors if there is
 * no data provided from backend
 */

if (typeof window.theme === 'undefined') {
	window.theme = {
		themeURL: '',
		ajax: {
			enabled: true,
			preventRules: '',
			evalInlineContainerScripts: false,
			loadMissingScripts: false,
			loadMissingStyles: false,
		},
		updateHeadNodes: '',
		updateScriptNodes: '',
		smoothScroll: {
			damping: 0.06,
			renderByPixels: true,
			continuousScrolling: false,
			plugins: {
				edgeEasing: true
			}
		},
		contactForm7: {
			customModals: false
		},
		mobileBarFix: {
			enabled: true,
			update: true
		},
		assets: {
			promises: []
		}
	};
}

/**
 * ScrollMagic Setup
 */
window.SMController = new ScrollMagic.Controller();
window.SMController.enabled(false);
window.SMSceneTriggerHook = 0.8;
window.SMSceneReverse = false;

/**
 * Don't save scroll position
 * after AJAX transition
 */
if ('scrollRestoration' in history) {
	history.scrollRestoration = 'manual';
}

window.$document.ready(function () {

	/**
	 * Split text only after ensuring
	 * that fonts are rendered
	 */
	Promise.all([,
		loadSwiper(),
		document.fonts.ready
	])
		.then(function () {
			return doSplitText();
		})
		.then(function () {
			return setLines();
		})
		.then(function () {
			initComponents(window.$document);
			window.$pageWrapper.removeClass('page-wrapper_hidden');
			window.SMController.enabled(true);
			window.SMController.update(true);
			window.$body.removeClass('cursor-progress');
		});

	new PJAX();
	new ProjectBackgrounds();
	window.InteractiveCursor = new Cursor();

});

function initComponents($scope = window.$document, scrollToHash = true) {

	new SmoothScroll();

	window.PageHeader = new Header();

	if (typeof window.PageMenu === 'undefined') {
		window.PageMenu = new MenuOverlay();
	}

	new Parallax($scope);
	new Grid();
	new Form();
	new SliderImages($scope);
	new SliderTestimonials($scope);
	new AsideCounters($scope);
	new GMap($scope);
	new SectionMasthead($scope);
	new SectionContent($scope);
	new SectionIntro($scope);
	new SectionTextSlider($scope);
	new SectionHeadingsSlider($scope);
	new SectionHalfScreenSlider($scope)
	new SectionNavProjects($scope)
	new SectionComposition($scope);
	new FigurePortfolio($scope);
	new FigureProperty($scope);
	$('.js-video').magnificPopup();
	lazyLoad($scope);

	if (window.theme.mobileBarFix.enabled) {
		fixMobileBarHeight();
	}

	// refresh animation triggers
	// for Waypoints library
	if (typeof Waypoint !== 'undefined') {
		Waypoint.refreshAll();
	}

	// Elementor Pro Lottie refresh
	if (typeof lottie !== 'undefined') {
		setTimeout(() => {
			lottie.play();
		}, 300);
	}

	// custom JS code
	if (window.theme.customJSInit) {
		try {
			window.eval(window.theme.customJSInit);
		} catch (error) {
			console.warn(error);
		}
	}

	if (scrollToHash && window.location.hash && !window.location.hash.startsWith('#elementor-action')) {
		setTimeout(() => {
			try {
				var
					$scrollElement = $(window.location.hash),
					time = 800;

				if ($scrollElement.length) {
					var offsetY = $scrollElement.offset().top;

					if (typeof window.SB !== 'undefined') {
							window.SB.scrollTo(0, offsetY, time);
						} else {
							$('html, body').animate({
								scrollTop: offsetY
							}, time);
						}

				}
			} catch (error) {
				console.warn(error);
			}
		}, 600);
	}

}
